import actions from './actions'
import mutations from './mutations'
import state from './state'
import getters from './getters'

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/drivers/store.js